"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFlavorPicker = void 0;

var _reactQuery = require("react-query");

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _head2 = _interopRequireDefault(require("lodash/head"));

var _split2 = _interopRequireDefault(require("lodash/split"));

var _toString2 = _interopRequireDefault(require("lodash/toString"));

var _api = require("../api");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useFlavorPicker = function useFlavorPicker() {
  var _a; // tslint:disable-next-line: strict-type-predicates


  var pathname = typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname : '';
  var locale = (0, _toString2["default"])((0, _head2["default"])((0, _compact2["default"])((0, _split2["default"])(pathname, '/'))));
  return (0, _reactQuery.useQuery)("FlavorPickerItems"
  /* FlavorPickerItems */
  , function () {
    return (0, _api.fetchFlavorPickerItems)(locale);
  }, {
    refetchOnWindowFocus: false,
    enabled: !!pathname && !!locale
  });
};

exports.useFlavorPicker = useFlavorPicker;